import React from 'react';
import PropTypes from 'prop-types';
import { StyledForm } from './styled';

const Form = ({ autoComplete, children, customStyle, onSubmit }) => {
    return (
        <StyledForm autoComplete={autoComplete} customStyle={customStyle} onSubmit={onSubmit}>
            {children}
        </StyledForm>
    );
};

Form.propTypes = {
    autoComplete: PropTypes.oneOf(['on', 'off']),
    children: PropTypes.node,
    customStyle: PropTypes.array,
    onSubmit: PropTypes.func
};

Form.defaultProps = {
    autoComplete: "on",
    onSubmit: undefined
};

export default React.memo(Form);
